import React from 'react';
import './App.scss';
import Layout from '../layout/Layout';
import { Route, Routes, Navigate } from 'react-router-dom';
import ExpertsMain from '../../mainPages/experts/ExpertsMain';
import EmployersMain from '../../mainPages/employers/EmployersMain';
import About from '../../mainPages/about/About';
import Faq from '../../mainPages/faq/Faq';
import Blog from '../../mainPages/blog/Blog';
import BlogFullVersion from '../../mainPages/blog/BlogFullVersion';
import ContactUs from '../../mainPages/ContactUs/ContactUs';
import { useState,useEffect } from 'react';
import Modal from '../../components/modal/Modal';
import GoTalkForm from '../../components/contact-form/goTalkForm/GoTalkForm';
import Success from '../../components/contact-form/success/Success';
import { useTranslation } from "react-i18next";
import "../../i18n";
import Privacy from '../../mainPages/Privacy/Privacy';
import CookiesPopUp from '../cookiesPopUp/CookiesPopUp';
import {Helmet, HelmetProvider } from 'react-helmet-async';
import CalculatorPage from '../../mainPages/calculatorPage/CalculatorPage';
import OgImage from '../../assets/img/Og.png';

 
function App() {
  const { t, i18n } = useTranslation();
  const modalContentForm = 'form';
  const modalContentSuccess = 'success';
  const modalContentFail = 'fail';
  const [currentModalContent, setCurrentModalContent] = useState(modalContentForm);
  const changeLanguages = (language) => {
    i18n.changeLanguage(language);
  };
  const lang = i18n.language;
  const [modalActive, setModalActive] = useState(false);

  const handlerSelectModal = () => {
    setModalActive(!modalActive);
  };
  const closeModal = () => {
    setModalActive(false)
  }

  const onFormSuccess = () => {
    setCurrentModalContent(modalContentSuccess);
  }

  const onFormFail = () => {
    // TODO fail form
  }
  let modalContent = <GoTalkForm t={t} onFormFail={onFormFail} onFormSuccess={onFormSuccess} />;
  switch(currentModalContent) {
    case modalContentFail:
      //todo fail
      break;
    case modalContentSuccess:
      modalContent = <Success t={t} handlerSelectModal={
        () => {
          closeModal();
          setCurrentModalContent(modalContentForm)
        }} />
        break;
      default: 
        modalContent = <GoTalkForm t={t} onFormFail={onFormFail} onFormSuccess={onFormSuccess} />;
  }
  const [popUpState, setPopUpState] = useState(false);
  useEffect(() => {

      localStorage.getItem("p_up_state") === "true"
      ? setPopUpState(false)
      : setPopUpState(true);
  
  }, []);
  const onClickPopUpAgreeButton = () => {
    localStorage.setItem("p_up_state", "true");
    setPopUpState(false);
  };
  const onClickPopUpDenyButton = () => {
    localStorage.setItem("p_up_state", "false");
    setPopUpState(false);
  };
  return (
    <HelmetProvider>
    <div className="app">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("head_title")}</title>
        <meta name="description" content={t("main_page_description")}></meta>
        <meta property="og:title" content={t("head_title")} />
        <meta property="og:description" content={t("main_page_description")} />
        <meta property="og:image" content={OgImage} />
        <link rel="canonical" href="https://weexpert.io/" />
      </Helmet>
      <div className="main-context-container">
        <Routes>
          <Route path='/:lang?' element={
            <React.Fragment>
               {popUpState && (<CookiesPopUp t={t} onClickPopUpAgreeButton={onClickPopUpAgreeButton} onClickPopUpDenyButton={onClickPopUpDenyButton}/>)}
            <Layout 
            lang = {lang}
              t={t} 
              changeLanguages={changeLanguages} 
              />
              </React.Fragment>
            }>
            <Route index element={<ExpertsMain t={t} handlerSelectModal={handlerSelectModal} />} />
            <Route path='employers' element={<EmployersMain t={t} handlerSelectModal={handlerSelectModal} />} />
            <Route path='about' element={<About t={t} handlerSelectModal={handlerSelectModal} />} />
            <Route path='faq' element={<Faq t={t} />} />
            <Route path='blog' element={< Blog lang={lang} t={t}/>} />
            <Route path='calculator' element={< CalculatorPage t={t}/>} />
            <Route path='post/:id' element={< BlogFullVersion t={t}/>} />
            <Route path='contacts' element={<ContactUs t={t} onFormFailSubmit={onFormFail} onFormSuccessSubmit={() => {
              onFormSuccess();
              setModalActive(true);
            }} />} />
          </Route>
          
          <Route exact path="/Privacy" element={<Privacy/>} />
        </Routes>
        <Modal t={t} setActive={handlerSelectModal} active={modalActive}>
          {modalContent}
        </Modal>
      </div>
    </div>
    </HelmetProvider>
  );
}

export default App;

